<mat-card appearance="outlined" class="card-primary patient-card" [class.patient-card-teacher]="teacher">
  <div style="display: flex; flex-direction: row">
    <ngx-skeleton-loader
      animation="progress"
      [theme]="{ width: '105px', height: '105px' }"
      count="1"
      appearance="line"></ngx-skeleton-loader>
    <div style="margin-left: 15px; display: flex; flex-direction: column">
      <ngx-skeleton-loader
        animation="progress"
        [theme]="{ width: '140px', marginTop: '5px', marginBottom: '0px', height: '25px' }"
        count="1"
        appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        animation="progress"
        [theme]="{ width: '90px', marginTop: '0px', marginBottom: '10px', height: '20px' }"
        count="1"
        appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        animation="progress"
        [theme]="{ width: '150px', marginTop: '0px', marginBottom: '0px', height: '10px' }"
        count="1"
        appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        animation="progress"
        [theme]="{ width: '150px', marginTop: '0px', marginBottom: '0px', height: '10px' }"
        count="1"
        appearance="line"></ngx-skeleton-loader>
    </div>
    <!-- <ngx-skeleton-loader animation="progress" [theme]="{width: '100%', marginTop: '0px', height: '40px'}" count="4"
            appearance="line"></ngx-skeleton-loader> -->
  </div>
</mat-card>
